import { render } from "./GraphHeader.vue?vue&type=template&id=8dbbbf02"
import script from "./GraphHeader.vue?vue&type=script&lang=js"
export * from "./GraphHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__